module.exports = function(obj) {

    return JSON.stringify(obj);
};


// WEBPACK FOOTER //
// ./resources/scripts/helpers/json.js